/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { accessDeleteDirectoryRoleMapping } from "../funcs/accessDeleteDirectoryRoleMapping.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DeleteDirectoryRoleMappingRequest,
  DeleteDirectoryRoleMappingSecurity,
} from "../models/operations/deletedirectoryrolemapping.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type DeleteDirectoryRoleMappingMutationVariables = {
  request: DeleteDirectoryRoleMappingRequest;
  security?: DeleteDirectoryRoleMappingSecurity | undefined;
  options?: RequestOptions;
};

export type DeleteDirectoryRoleMappingMutationData = void;

export type DeleteDirectoryRoleMappingMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * deleteDirectoryRoleMapping access
 *
 * @remarks
 * Remove a directory role mapping.
 */
export function useDeleteDirectoryRoleMappingMutation(
  options?: MutationHookOptions<
    DeleteDirectoryRoleMappingMutationData,
    DeleteDirectoryRoleMappingMutationError,
    DeleteDirectoryRoleMappingMutationVariables
  >,
): UseMutationResult<
  DeleteDirectoryRoleMappingMutationData,
  DeleteDirectoryRoleMappingMutationError,
  DeleteDirectoryRoleMappingMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildDeleteDirectoryRoleMappingMutation(client, options),
    ...options,
  });
}

export function mutationKeyDeleteDirectoryRoleMapping(): MutationKey {
  return ["@gram/client", "access", "deleteDirectoryRoleMapping"];
}

export function buildDeleteDirectoryRoleMappingMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: DeleteDirectoryRoleMappingMutationVariables,
  ) => Promise<DeleteDirectoryRoleMappingMutationData>;
} {
  return {
    mutationKey: mutationKeyDeleteDirectoryRoleMapping(),
    mutationFn: function deleteDirectoryRoleMappingMutationFn({
      request,
      security,
      options,
    }): Promise<DeleteDirectoryRoleMappingMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(accessDeleteDirectoryRoleMapping(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
